import { render, staticRenderFns } from "./CreateOrder.pug?vue&type=template&id=19d99206&lang=pug&"
import script from "./CreateOrder.ts?vue&type=script&lang=ts&"
export * from "./CreateOrder.ts?vue&type=script&lang=ts&"
import style0 from "./CreateOrder.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports